<lib-box-list
  *ngIf="
    all_posture_count !== null &&
    tenant_posture_controls_in_this_period !== null &&
    group_posture_controls_in_this_period !== null
  "
  [title]="'Baselines'"
  [tenant_posture_counts]="all_posture_count.tenant_count"
  [group_posture_counts]="all_posture_count.group_count"
  [tenant_baselines_posture_controls_in_this_period]="tenant_posture_controls_in_this_period"
  [group_baselines_posture_controls_in_this_period]="group_posture_controls_in_this_period"
  [keys]="['timestamp', 'category', 'name']"
  [type]="'baseline deviation'"
>
</lib-box-list>

<lib-box-list
  *ngIf="alerts !== null"
  [title]="'Alerts'"
  [arrayList]="alerts"
  [keys]="['timestamp', 'actor', 'description']"
  [type]="'event'"
>
</lib-box-list>

<div *ngIf="alertsByUsers !== null">
  <ng-container *ngIf="alertsByUsers.length > 0; else empty">
    <div *ngFor="let user of alertsByUsers">
      <lib-box-list
        [title]="user.actor"
        [arrayList]="userAlerts(user.alerts)"
        [keys]="['timestamp', 'actor', 'description']"
        [type]="'event'"
      >
      </lib-box-list>
    </div>
  </ng-container>
</div>

<div *ngIf="psaTicketCount !== null">
  <ng-container *ngIf="psaTicketCount.length > 0; else NoPSA">
    <div *ngFor="let count of psaTicketCount">
      <lib-box-list
        [title]="'Tickets'"
        [open_ticket_count]="count.all_time_opening"
        [created_ticket_count]="count.created"
        [resolved_ticket_count]="count.resolved"
        [type]="'ticket'"
      >
      </lib-box-list>
    </div>
  </ng-container>
</div>

<ng-template #empty>
  <p class="empty">
    <mat-icon class="safe" mat-list-icon svgIcon="task_alt"></mat-icon>
    No users under threats were found
  </p>
</ng-template>

<ng-template #NoPSA>
  <p style="font-style: italic; font-size: smaller">
    <mat-icon style="color: grey; font-size: 1rem" svgIcon="info"></mat-icon>No PSA Alert Ticket Integration has configured yet.
  </p>
</ng-template>
